import React, { useState } from 'react';
import TabLayout from 'components/tab-components/TabLayout';
import TabHeader from 'components/tab-components/TabHeader';
import TabBody from 'components/tab-components/TabBody';
import { dashboardsSetupTabsList } from './utils';
import FormMetaAndSQL from './form-meta-and-sql/FormMetaAndSQL';

const DashboardsSetup = () => {
  const [selectedTab, setSelectedTab] = useState(dashboardsSetupTabsList[0]);
  return (
    <>
      <TabLayout>
        <TabHeader
          tabList={dashboardsSetupTabsList}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <TabBody>
          <FormMetaAndSQL type={selectedTab.value} />
        </TabBody>
      </TabLayout>
    </>
  );
};

export default DashboardsSetup;
